/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.VerifyRecaptchaResponse,
  verifyRecaptcha: (params: vp.VerifyRecaptchaRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostVerifyRecaptcha: ApiHook = ({ api }) => {
  const [shouldVerifyRecaptcha, setShouldVerifyRecaptcha] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.VerifyRecaptchaRequest>({
    response: '',
  });
  const [response, setResponse] = useState<vp.VerifyRecaptchaResponse>({
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    if (!shouldVerifyRecaptcha) return () => {};

    const ChangeUserPassword = async () => {
      const res = await api.postVerifyRecaptcha(params, source);
      setResponse(res);
    };

    if (shouldVerifyRecaptcha) void ChangeUserPassword();
    setShouldVerifyRecaptcha(false);
    return () => {
      source.cancel();
    };
  }, [shouldVerifyRecaptcha]);

  return [
    response,
    (_params: vp.VerifyRecaptchaRequest) => {
      setParams(_params);
      setShouldVerifyRecaptcha(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setShouldVerifyRecaptcha(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostVerifyRecaptcha);
